import { TASK_STATUS_QUERY } from "../constants/graphql";
export default {
  data() {
    return {
      checkStatus: false,
      taskID: "",
      message: "",
    };
  },

  apollo: {
    taskStatus: {
      query: TASK_STATUS_QUERY,
      variables: function () {
        return { taskId: this.taskID };
      },
      result({ data, loader, networkStatus }) {
        this.checkStatus = false;
        if (data.taskStatus.status == "IN_PROGRESS") {
          this.message = data.taskStatus.notes
            ? data.taskStatus.notes
            : "In progress...";
          setTimeout(() => {
            this.checkStatus = true;
          }, 2000);
        } else if(data.taskStatus.status == "ERROR") {
          console.log(data);
          this.taskStatusCompleteHandler(data);
        } else {
          //console.log(data.taskStatus.notes);
          this.taskStatusCompleteHandler(data);
        }
      },
      skip() {
        return !this.checkStatus;
      },
      fetchPolicy: "network-only",
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/TaskStatusMixin.js